import React from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { EDIT_GOALS, EDIT_MATOMO } from 'shared/constants/permissions';
import AnalyticsSettings from './AnalyticsSettings';
import ActionDimensionSettings from './ActionDimensionSettings';
import VisitDimensionSettings from './VisitDimensionSettings';
import ManageGoals from './ManageGoals';
import CampaignUrlBuilder from './CampaignUrlBuilder';

const routes = [{
  path: 'dashboard',
  label: 'Dashboards',
  link: false,
  emptyLabel: 'No dashboards',
}, {
  path: 'visitors',
  label: 'Visitors',
  link: false,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'visits-log',
    label: 'Visits log',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'Live_VisitorLog',
    },
  }, {
    path: 'real-time',
    label: 'Real-time',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'General_RealTime',
    },
  }, {
    path: 'real-time-map',
    label: 'Real-time map',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'UserCountryMap_RealTimeMap',
    },
  }, {
    path: 'locations',
    label: 'Locations',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'UserCountry_SubmenuLocations',
    },
  }, {
    path: 'devices',
    label: 'Devices',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'DevicesDetection_Devices',
    },
  }, {
    path: 'software',
    label: 'Software',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'DevicesDetection_Software',
    },
  }, {
    path: 'times',
    label: 'Times',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'VisitTime_SubmenuTimes',
    },
  }, {
    path: 'user-ids',
    label: 'User IDs',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'UserId_UserReportTitle',
    },
  }, {
    path: 'cohorts',
    label: 'Cohorts',
    matomoUrlParams: {
      category: 'General_Visitors',
      subcategory: 'Cohorts_Cohorts',
    },
  }],
}, {
  path: 'behavior',
  label: 'Behavior',
  link: false,
  children: [{
    path: 'pages',
    label: 'Pages',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'General_Pages',
    },
  }, {
    path: 'entry-pages',
    label: 'Entry pages',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Actions_SubmenuPagesEntry',
    },
  }, {
    path: 'exit-pages',
    label: 'Exit pages',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Actions_SubmenuPagesExit',
    },
  }, {
    path: 'page-titles',
    label: 'Page titles',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Actions_SubmenuPageTitles',
    },
  }, {
    path: 'site-search',
    label: 'Site search',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Actions_SubmenuSitesearch',
    },
  }, {
    path: 'outlinks',
    label: 'Outlinks',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'General_Outlinks',
    },
  }, {
    path: 'downloads',
    label: 'Downloads',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'General_Downloads',
    },
  }, {
    path: 'events',
    label: 'Events',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Events_Events',
    },
  }, {
    path: 'contents',
    label: 'Contents',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Contents_Contents',
    },
  }, {
    path: 'engagement',
    label: 'Engagement',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'VisitorInterest_Engagement',
    },
  }, {
    path: 'transitions',
    label: 'Transitions',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'Transitions_Transitions',
    },
  }, {
    path: 'performance',
    label: 'Performance',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'PagePerformance_Performance',
    },
  }, {
    path: 'users-flow',
    label: 'Users flow',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'UsersFlow_UsersFlow',
    },
  }, {
    path: 'top-paths',
    label: 'Top paths',
    matomoUrlParams: {
      category: 'General_Actions',
      subcategory: 'UsersFlow_TopPaths',
    },
  }],
}, {
  path: 'acquisition',
  label: 'Acquisition',
  link: false,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'channels',
    label: 'Channels',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_WidgetGetAll',
    },
  }, {
    path: 'search-engines',
    label: 'Search engines',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_SubmenuSearchEngines',
    },
  }, {
    path: 'websites',
    label: 'Websites',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_SubmenuWebsitesOnly',
    },
  }, {
    path: 'social-networks',
    label: 'Social networks',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_Socials',
    },
  }, {
    path: 'ai-assistants',
    label: 'AI assistants',
    new: true,
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_AIAssistants',
    },
  }, {
    path: 'campaigns',
    label: 'Campaigns',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'Referrers_Campaigns',
    },
  }, {
    path: 'seo-web-vitals',
    label: 'SEO Web Vitals',
    matomoUrlParams: {
      category: 'Referrers_Referrers',
      subcategory: 'SEOWebVitals_SEOWebVitals',
    },
    licenseSetting: 'seoWebVitals',
  }, {
    path: 'campaign-url-builder',
    label: 'Campaign URL builder',
    component: CampaignUrlBuilder,
  }],
}, {
  path: 'ecommerce',
  label: 'Ecommerce',
  link: false,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'Goals_Ecommerce',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'log',
    label: 'Ecommerce log',
    matomoUrlParams: {
      category: 'Goals_Ecommerce',
      subcategory: 'Goals_EcommerceLog',
    },
  }, {
    path: 'products',
    label: 'Products',
    matomoUrlParams: {
      category: 'Goals_Ecommerce',
      subcategory: 'Goals_Products',
    },
  }, {
    path: 'sales',
    label: 'Sales',
    matomoUrlParams: {
      category: 'Goals_Ecommerce',
      subcategory: 'Ecommerce_Sales',
    },
  }, {
    path: 'multi-attribution',
    label: 'Multi attribution',
    matomoUrlParams: {
      category: 'Goals_Ecommerce',
      subcategory: 'MultiChannelConversionAttribution_MultiAttribution',
    },
  }],
}, {
  path: 'goals',
  label: 'Goals & Funnels',
  link: false,
  activeEmptyLabel: 'No active goals',
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'Goals_Goals',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'multi-attribution',
    label: 'Multi attribution',
    matomoUrlParams: {
      category: 'Goals_Goals',
      subcategory: 'MultiChannelConversionAttribution_MultiAttribution',
    },
    licenseSetting: 'multiAttribution',
  }],
}, {
  path: 'forms',
  label: 'Forms',
  link: false,
  noDemoData: true,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'FormAnalytics_Forms',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'real-time',
    label: 'Real-time',
    matomoUrlParams: {
      category: 'FormAnalytics_Forms',
      subcategory: 'FormAnalytics_TypeRealTime',
    },
  }],
}, {
  path: 'media',
  label: 'Media',
  link: false,
  noDemoData: true,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'General_Overview',
    },
  }, {
    path: 'real-time',
    label: 'Real-time',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_TypeRealTime',
    },
  }, {
    path: 'video',
    label: 'Video',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_TypeVideo',
    },
  }, {
    path: 'audio',
    label: 'Audio',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_TypeAudio',
    },
  }, {
    path: 'media-players',
    label: 'Media players',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_MediaPlayers',
    },
  }, {
    path: 'audience-log',
    label: 'Audience log',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_TypeAudienceLog',
    },
  }, {
    path: 'audience-map',
    label: 'Audience map',
    matomoUrlParams: {
      category: 'MediaAnalytics_Media',
      subcategory: 'MediaAnalytics_TypeAudienceMap',
    },
  }],
}, {
  path: 'custom-reports',
  label: 'Custom reports',
  link: false,
  emptyLabel: 'No custom reports',
}, {
  path: 'crashes',
  label: 'Crashes',
  link: false,
  noDemoData: true,
  children: [{
    path: 'overview',
    label: 'Overview',
    matomoUrlParams: {
      category: 'CrashAnalytics_Crashes',
      subcategory: 'CrashAnalytics_Overview',
    },
  }, {
    path: 'real-time',
    label: 'Real-time',
    matomoUrlParams: {
      category: 'CrashAnalytics_Crashes',
      subcategory: 'CrashAnalytics_RealTime',
    },
  }, {
    path: 'all-crashes',
    label: 'All crashes',
    matomoUrlParams: {
      category: 'CrashAnalytics_Crashes',
      subcategory: 'CrashAnalytics_AllCrashes',
    },
  }],
}, {
  type: 'divider',
  dataSourcePermission: EDIT_MATOMO,
}, {
  path: 'settings',
  label: 'Settings',
  link: false,
  icon: <SettingOutlined />,
  dataSourcePermission: EDIT_MATOMO,
  children: [{
    path: 'tracking',
    label: 'Tracking',
    component: AnalyticsSettings,
  }, {
    path: 'visit-dimensions',
    label: 'Visit dimensions',
    component: VisitDimensionSettings,
  }, {
    path: 'action-dimensions',
    label: 'Action dimensions',
    component: ActionDimensionSettings,
  }, {
    path: 'goals',
    label: 'Goals',
    dataSourcePermission: EDIT_GOALS,
    component: ManageGoals,
  }, {
    path: 'forms',
    label: 'Forms',
    matomoUrlParams: {
      category: 'FormAnalytics_Forms',
      subcategory: 'FormAnalytics_ManageForms',
    },
  }, {
    path: 'custom-reports',
    label: 'Custom reports',
    matomoUrlParams: {
      category: 'CustomReports_CustomReports',
      subcategory: 'CustomReports_ManageReports',
    },
  }],
}];

export default routes;
